<div class="fixed w-full h-full inset-0 flex items-center justify-center" 
     style="z-index: 999;"
>
    <div class="relative  bg-white w-full h-full flex items-center justify-center "
        [ngClass]="{
            'animation-bg-close': animationLogo == 2
        }">
        <div class="w-full h-full flex items-center justify-center"
             [ngClass]="{
                 'animation-spin-logo-up': animationLogo == 1,
             }"
             style="max-width: 350px;"
        >
            <img src="icons/tools/logo/Cityparking_mascot_logo.png" />
        </div>
    </div>
</div>